import { z } from 'zod';

export const MessageType = z.enum([
  'iframe-ready',
  'initialize-widget',
  'analytic',
  'extend-analytics',
  'viewport-change',
  'widget-initialized',
  'extend-context',
  'extend-tracking-parameters',
  'extend-more-ticket-info',
  'set-language',
]);
